module.exports = __webpack_public_path__ + "img/our-01.212cf4f3.png";